/**
 * MUSKLE Phase B — progressive collection grid for /collections/all.
 * Loads server-rendered Liquid product-card batches via Section Rendering API.
 * No JS card rebuild. No automatic full-catalog prefetch.
 */
(function () {
  'use strict';

  if (window.__MUSKLE_COLLECTION_PROGRESSIVE_BOOTED__) return;
  window.__MUSKLE_COLLECTION_PROGRESSIVE_BOOTED__ = true;

  var PAGE_SIZE = 24;
  var fullyLoadedPages = new Set();
  var pageHtmlCache = new Map();
  var pageCardsCache = new Map();
  var inFlight = new Map();
  var ensureToken = 0;

  function resultsList() {
    return document.querySelector('results-list[data-muskle-progressive-all="true"]');
  }

  function gridEl() {
    return document.querySelector('#ResultsList ul.product-grid, results-list[data-muskle-progressive-all] ul.product-grid');
  }

  function sectionId() {
    var root = resultsList();
    var fromBtn = document.querySelector('[data-muskle-collection-load-more]');
    return (
      (root && root.getAttribute('section-id')) ||
      (fromBtn && fromBtn.getAttribute('data-section-id')) ||
      ''
    );
  }

  function loadMoreRoot() {
    return document.querySelector('[data-muskle-collection-load-more]');
  }

  function lastPage() {
    var root = loadMoreRoot();
    var grid = gridEl();
    var fromRoot = root ? Number(root.getAttribute('data-last-page') || 0) : 0;
    var fromGrid = grid ? Number(grid.getAttribute('data-last-page') || 0) : 0;
    return Math.max(fromRoot, fromGrid, 1);
  }

  function nextBrowsePage() {
    var n = 1;
    var last = lastPage();
    while (n <= last && fullyLoadedPages.has(n)) n += 1;
    return n;
  }

  function markInitialPage() {
    document.querySelectorAll('.product-grid__item[data-page]').forEach(function (el) {
      var p = Number(el.getAttribute('data-page') || 0);
      if (p) fullyLoadedPages.add(p);
    });
    // Contiguous prefix only — sparse filter hydrations must not advance Load More.
    var prefix = new Set();
    for (var i = 1; i <= lastPage(); i++) {
      if (!fullyLoadedPages.has(i)) break;
      prefix.add(i);
    }
    fullyLoadedPages = prefix;
  }

  function buildSectionUrl(pageNumber) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(pageNumber));
    url.searchParams.set('section_id', sectionId());
    url.hash = '';
    return url.toString();
  }

  function parseCardsFromHtml(html, pageNumber) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.querySelector('[ref="grid"], ul.product-grid');
    if (!grid) return [];
    var nodes = grid.querySelectorAll(':scope > [ref="cards[]"], :scope > .product-grid__item');
    var out = [];
    nodes.forEach(function (node) {
      var clone = document.importNode(node, true);
      if (!clone.getAttribute('data-page')) clone.setAttribute('data-page', String(pageNumber));
      out.push(clone);
    });
    return out;
  }

  function fetchPage(pageNumber) {
    pageNumber = Number(pageNumber);
    if (!pageNumber || !sectionId()) return Promise.resolve([]);
    if (pageCardsCache.has(pageNumber)) return Promise.resolve(pageCardsCache.get(pageNumber));
    if (inFlight.has(pageNumber)) return inFlight.get(pageNumber);

    var promise = fetch(buildSectionUrl(pageNumber), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('section_fetch_' + res.status);
        return res.text();
      })
      .then(function (html) {
        pageHtmlCache.set(pageNumber, html);
        var cards = parseCardsFromHtml(html, pageNumber);
        pageCardsCache.set(pageNumber, cards);
        inFlight.delete(pageNumber);
        return cards;
      })
      .catch(function (err) {
        inFlight.delete(pageNumber);
        console.warn('[muskle-progressive] page fetch failed', pageNumber, err);
        return [];
      });

    inFlight.set(pageNumber, promise);
    return promise;
  }

  function existingIds() {
    var set = new Set();
    document.querySelectorAll('.product-grid__item[data-product-id]').forEach(function (el) {
      set.add(String(el.getAttribute('data-product-id')));
    });
    return set;
  }

  function pageForIndex(index) {
    return Math.floor(index / PAGE_SIZE) + 1;
  }

  function updateLoadMoreUi() {
    var root = loadMoreRoot();
    if (!root) return;
    var btn = root.querySelector('[data-muskle-load-more-btn]');
    if (!btn) return;
    var next = nextBrowsePage();
    var last = lastPage();
    root.setAttribute('data-current-page', String(Math.max(next - 1, 1)));
    if (next > last) {
      btn.setAttribute('hidden', '');
      btn.disabled = true;
    } else {
      btn.removeAttribute('hidden');
      btn.disabled = false;
    }
  }

  function appendCards(cards) {
    var grid = gridEl();
    if (!grid || !cards.length) return 0;
    var have = existingIds();
    var added = 0;
    cards.forEach(function (card) {
      var id = String(card.getAttribute('data-product-id') || '');
      if (!id || have.has(id)) return;
      grid.appendChild(card);
      have.add(id);
      added += 1;
    });
    return added;
  }

  /**
   * Ensure specific product IDs exist in the grid (catalog order).
   * Fetches only required server pages; never refetches pages already loaded.
   */
  function ensureProductIds(orderedIds, pageSize) {
    if (pageSize) PAGE_SIZE = Number(pageSize) || PAGE_SIZE;
    var token = ++ensureToken;
    var want = (orderedIds || []).map(String);
    var catalog = window.MuskleCatalogFilters && window.MuskleCatalogFilters.products;
    var indexById = new Map();
    if (Array.isArray(catalog)) {
      catalog.forEach(function (p, i) {
        indexById.set(String(p.id), i);
      });
    }

    var pagesNeeded = new Set();
    var have = existingIds();
    want.forEach(function (id) {
      if (have.has(id)) return;
      var idx = indexById.has(id) ? indexById.get(id) : -1;
      if (idx < 0) return;
      pagesNeeded.add(pageForIndex(idx));
    });

    var pages = [...pagesNeeded].filter(function (p) {
      return p >= 1 && p <= lastPage();
    }).sort(function (a, b) {
      return a - b;
    });

    if (!pages.length) {
      updateLoadMoreUi();
      return Promise.resolve({ added: 0, pages: [] });
    }

    return pages
      .reduce(function (chain, page) {
        return chain.then(function (acc) {
          if (token !== ensureToken) return acc;
          return fetchPage(page).then(function (cards) {
            acc.pages.push(page);
            acc.cardLists.push(cards);
            return acc;
          });
        });
      }, Promise.resolve({ pages: [], cardLists: [] }))
      .then(function (acc) {
        if (token !== ensureToken) return { added: 0, pages: acc.pages };
        var byId = new Map();
        acc.cardLists.forEach(function (list) {
          list.forEach(function (card) {
            byId.set(String(card.getAttribute('data-product-id') || ''), card);
          });
        });

        var grid = gridEl();
        if (!grid) return { added: 0, pages: acc.pages };
        have = existingIds();
        var added = 0;

        // Insert missing matched cards in catalog order after the last already-present earlier card.
        want.forEach(function (id) {
          if (have.has(id)) return;
          var card = byId.get(id);
          if (!card) return;
          var clone = card.cloneNode(true);
          var insertBefore = null;
          var myIndex = indexById.has(id) ? indexById.get(id) : Number.MAX_SAFE_INTEGER;
          grid.querySelectorAll('.product-grid__item[data-product-id]').forEach(function (el) {
            var elId = String(el.getAttribute('data-product-id') || '');
            var elIndex = indexById.has(elId) ? indexById.get(elId) : -1;
            if (elIndex > myIndex && !insertBefore) insertBefore = el;
          });
          if (insertBefore) grid.insertBefore(clone, insertBefore);
          else grid.appendChild(clone);
          have.add(id);
          added += 1;
        });

        updateLoadMoreUi();
        document.dispatchEvent(
          new CustomEvent('muskle:collection-cards-added', { detail: { added: added, pages: acc.pages } })
        );
        return { added: added, pages: acc.pages };
      });
  }

  function loadNextPage() {
    var next = nextBrowsePage();
    var last = lastPage();
    if (next > last) {
      updateLoadMoreUi();
      return Promise.resolve({ added: 0 });
    }
    var btn = document.querySelector('[data-muskle-load-more-btn]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    return fetchPage(next)
      .then(function (cards) {
        var added = appendCards(cards);
        fullyLoadedPages.add(next);
        updateLoadMoreUi();
        document.dispatchEvent(
          new CustomEvent('muskle:collection-cards-added', { detail: { added: added, pages: [next] } })
        );
        return { added: added, page: next };
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          updateLoadMoreUi();
        }
      });
  }

  function onClick(event) {
    var btn = event.target.closest('[data-muskle-load-more-btn]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    loadNextPage();
  }

  function boot() {
    if (!resultsList() && !loadMoreRoot()) return;
    markInitialPage();
    updateLoadMoreUi();
    document.addEventListener('click', onClick);

    window.MuskleCollectionProgressive = {
      loadNextPage: loadNextPage,
      ensureProductIds: ensureProductIds,
      fullyLoadedPages: fullyLoadedPages,
      pageSize: function () {
        return PAGE_SIZE;
      },
      setPageSize: function (n) {
        PAGE_SIZE = Number(n) || PAGE_SIZE;
      },
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
